import { render } from "./ThreadEdit.vue?vue&type=template&id=cb0215c4"
import script from "./ThreadEdit.vue?vue&type=script&lang=js"
export * from "./ThreadEdit.vue?vue&type=script&lang=js"
script.render = render

export default script